module.exports = __webpack_public_path__ + "static/img/13.eb19f44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/13.png
// module id = 7Fke
// module chunks = 0